<div class="how-it-works">
  <img
    id="how-it-works"
    class="lazyload responsive-img"
    [alt]="'how-it-works-alt-description' | translate"
    src="{{ imagePlaceholder + '?w=800&h=800&auto=format' }}"
    [attr.data-src]="environment.imgixHost + ('how-it-works-image-link' | translate)"
  />
</div>
